import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['title']
  static values = {
    title: String
  }

  titleValueChanged() {
    if (this.hasTitleTarget) {
      this.titleTarget.textContent = this.titleValue
    }
  }
}